/**
 * @file ppde页关于我们视频窗口
 * @author FengGuang(fengguang01@baidu.com)
 */
import React, {useCallback, useRef} from 'react';
import VideoCover from '../../../../../../components/video-cover/VideoCover';
import VideoModal from '../../../../../../components/video-modal/VideoModal';
import {IAboutUsVideoProps} from '../../types';

const VideoItem: React.FC<IAboutUsVideoProps> = (props) => {
    const {
        coverImg,
        coverVideo,
        video
    } = props;

    const videoCoverRef = useRef<HTMLVideoElement>(null);

    const handleOnMouseEnter = useCallback(() => {
        if (videoCoverRef.current) {
            videoCoverRef.current.play();
        }
    }, []);
    const handleOnMouseLeave = useCallback(() => {
        if (videoCoverRef.current) {
            videoCoverRef.current.pause();
        }
    }, []);

    return (
        <VideoModal
            src={video}
        >
            <div className="paddle-ppde-about-us-video">
                <div
                    className="paddle-ppde-about-us-video-wrap"
                    onMouseEnter={handleOnMouseEnter}
                    onMouseLeave={handleOnMouseLeave}
                    style={{backgroundImage: coverImg ? `url(${coverImg})` : undefined}}
                >
                    <VideoCover
                        className="paddle-ppde-about-us-video-main"
                        src={coverVideo}
                        ref={videoCoverRef}
                    />
                    {!!coverVideo
                    && (
                        <i className="paddle-ppde-about-us-video-play-icon" />
                    )}
                </div>
                <div className="paddle-ppde-about-us-video-range" />
            </div>
        </VideoModal>
    );
};

export default VideoItem;
